import { render } from "./piecePath.vue?vue&type=template&id=d85dc440&ts=true"
import script from "./piecePath.vue?vue&type=script&lang=ts"
export * from "./piecePath.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__